// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"509edbb7","769":"1e63b6e8"}[chunkId] + ".chunk.js";
};